import { GetterTree, MutationTree } from 'vuex';
import { State } from '../types/tag';

export const state: () => State = () => ({
  tempData: null,
});

export const getters: GetterTree<State, Record<string, unknown>> = {
  getTempData: state => state.tempData,
};

export const mutations: MutationTree<State> = {
  setTempData(state, value: State['tempData']) {
    state.tempData = {
      tag: value?.tag || null,
      headlines: value?.headlines || null,
    };
  },
  resetTempData(state) {
    state.tempData = null;
  },
};
